import Phaser from 'phaser';
import { GAME_CONFIG } from '../config';

export class PreloadScene extends Phaser.Scene {
  constructor() {
    super({ key: 'PreloadScene' });
  }

  preload(): void {
    const { TILE_SIZE } = GAME_CONFIG;

    this.load.image('tiles-atlas', 'atlases/tiles.png');
    // The walker is the keyed cozy reader sheet (art/output/p1-player-draft-
    // 1k-v2-cropped.sheet.png, copied here as player-cozy.png): 4 columns
    // (down/left/right/up) x 2 rows (small bordered preview, larger
    // detailed turnaround) of 16x32 frames — see Player.ts for how frames
    // are picked. The male reader draft is not processed/used here.
    this.load.spritesheet('player-atlas', 'atlases/player-cozy.png', {
      frameWidth: TILE_SIZE,
      frameHeight: TILE_SIZE * 2,
    });
    this.load.image('player-portrait', 'atlases/portrait.png');
    this.load.tilemapTiledJSON('library-map', 'maps/library.json');
  }

  create(): void {
    this.scene.start('LibraryScene');
  }
}
